import { render } from "./AccessibilityView.vue?vue&type=template&id=a08f5c94&scoped=true&ts=true"
import script from "./AccessibilityView.vue?vue&type=script&lang=ts"
export * from "./AccessibilityView.vue?vue&type=script&lang=ts"

import "./AccessibilityView.vue?vue&type=style&index=0&id=a08f5c94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08f5c94"]])

export default __exports__